import { requestLegalAgreement } from '../api/legalAgreementGate';
import { useProfile } from './useProfile';

/**
 * Soft-гейт: при `legal_agreement_accepted === false` мутации ПДн/заказа
 * в UI недоступны; чтение ЛК не блокируется.
 */
export function useLegalMutationsAllowed(): {
  allowed: boolean;
  /** Открыть LegalAgreementModal (клик по неактивной CTA). */
  requireConsent: () => void;
} {
  const profile = useProfile(true);
  const allowed = profile?.legal_agreement_accepted !== false;

  return {
    allowed,
    requireConsent: requestLegalAgreement,
  };
}
